import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import Priority from './Priority';

const PriorityWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Resultados dos Chamados',
            }}
        >
            <Priority />
        </ServicesChartsDataProvider>
    );
};

export default PriorityWrapper;
